import api from '../../api/'
import { Teams } from 'src/api/resources'
import * as types from '../mutation-types'

export const getAllTeams = ({ dispatch, state }) => {
  if (state.teams.all.length === 0) {
    dispatch(types.ASYNC_REQUEST)
    return api
      .getTeams()
      .then(response => {
        dispatch(types.RECEIVE_TEAMS, response.data)
        dispatch(types.ASYNC_SUCCESS)
      })
      .catch(error => {
        console.log(error)
        dispatch(types.ASYNC_FAILURE, error.data.code)
      })
  }
}
export const newTeam = ({ dispatch, state }, team) => {
  return Teams.save(team).then((response) => dispatch(types.ADD_TEAM, response.data))
}

export const deleteTeam = ({ dispatch, state }, id) => {
  return Teams.delete({id: id})
}

export const addSession = ({ dispatch, state }) => dispatch(types.ADD_SESSION)
export const deleteSession = ({ dispatch, state }, id) => dispatch(types.DELETE_SESSION, id)
export const setActiveTeam = ({ dispatch, state }, id) => {
  if (state.teams.all.length === 0) {
    dispatch(types.ASYNC_REQUEST)
    api.getTeams()
    .then(response => {
      dispatch(types.RECEIVE_TEAMS, response.data)
      dispatch(types.ASYNC_SUCCESS)
      dispatch(types.SET_ACTIVE_TEAM, id)
    })
  } else {
    dispatch(types.SET_ACTIVE_TEAM, id)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/teams/actions.js